import { Matrix3d } from "@itwin/core-geometry";


export function RotateX(thetaX: number): Matrix3d {
        const sinThetaX = Math.sin(thetaX);
        const cosThetaX = Math.cos(thetaX);
        const xRotate = new Float64Array([1, 0, 0, 0, cosThetaX, -sinThetaX, 0, sinThetaX, cosThetaX]);
    const xRotateMatrix = new Matrix3d(xRotate);
    return xRotateMatrix;
    }

export function RotateY(thetaY: number): Matrix3d {
    const sinThetaY = Math.sin(thetaY);
    const cosThetaY = Math.cos(thetaY);
    const yRotate = new Float64Array([cosThetaY, 0, sinThetaY, 0, 1, 0, -sinThetaY, 0, cosThetaY]);
    const yRotateMatrix = new Matrix3d(yRotate);
    return yRotateMatrix;
}

export function RotateZ(thetaZ: number): Matrix3d {
    const sinThetaZ = Math.sin(thetaZ);
    const cosThetaZ = Math.cos(thetaZ);
    const zRotate = new Float64Array([cosThetaZ, -sinThetaZ, 0, sinThetaZ, cosThetaZ, 0, 0, 0, 1]);
    const zRotateMatrix = new Matrix3d(zRotate);
    return zRotateMatrix;
}
